import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";
import queryString from "query-string";
import {cartRegister} from "../../services/cartRegister";
import {scraperRegister} from "../../services/scraperRegister";
import {BeatLoader} from "react-spinners";

class SignupAdsGoogleDisplay extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            learn_more: false,
            quotes: null,
            market: null,
            image: null,
            customIndustry: null,
            tips: [],
            industry: {},
            ad_types: {
                canvas: {available: true, selected: true},
                carousel: {available: true, selected: false},
                video: {available: true, selected: false}
            },
            available: false
        };
    };

    componentDidMount() {
        this._updateData();
    }

    _updateData() {
        this.setState({
            tips: [
                {title: this._renderText("item_74")},
                {title: this._renderText("item_75")},
                {title: this._renderText("item_76")},
                {title: this._renderText("item_77")},
                {title: this._renderText("item_78")},
                {title: this._renderText("item_79")}
            ],
            selected: this.props.setChannel,
            quotes: this.props.setQuotes,
            industry: this.props.setIndustry,
            image: this.props.setImage,
            customIndustry: this.props.setCustomIndustry,
            market: salesChannelRegister.get('market'),
            available: this.props.setAvailable
        });
    }

    _placement() {
        try {
            let query = {
                industry: this.state.industry.name,
                region: salesChannelRegister.get("market"),
                quotes: "| " + this._renderQuotes(),
                website: this._renderText("item_60") + salesChannelRegister.get("market"),
                frame: this.state.frame,
                //image: this.state.image.id === "uploaded_image"?"uploaded_image":this.state.image.url,
                saleschannel: salesChannelRegister.get("name"),
                pageTitle: salesChannelRegister.get('socialTitle'),
                pageImage: salesChannelRegister.get('socialIcon')
            };

            if (this.state.image.id === "uploaded_image") {
                query.image = this.state.image.web_url ? this.state.image.web_url : "uploaded_image";
            } else {
                query.image = this.state.image.url;
            }

            const stringified = queryString.stringify(query);
            let url = 'https://placement.' + dataRegister.domain;
            var popUp = window.open(url + "/" + langRegister.lang() + "/googledisplay?" + stringified, '_blank');
            if (!this.state.image.web_url) {
                setTimeout(() => {
                    popUp.postMessage(this.state.image.data_url, url);
                }, 500)
            }

        } catch (e) {
            window.open('https://placement.' + dataRegister.domain + "/" + langRegister.lang() + "/googledisplay", '_blank');
        }
    }

    _selectAdType(item) {
        try {
            for (let key in this.state.ad_types) {
                if (key === item) {
                    this.state.ad_types[key].selected = true;
                } else {
                    this.state.ad_types[key].selected = false;
                }
            }
            this.setState({ad_types: this.state.ad_types})
        } catch (e) {
        }
    }

    _renderQuotes() {
        if (this.state.quotes) {
            let quotes_string = "";
            if (!this.state.quotes.custom) {
                let i = 1;
                var sortable = [];
                for (var key in this.state.quotes) {
                    sortable.push([this.state.quotes[key], this.state.quotes[key].index]);
                }
                sortable.sort(function (a, b) {
                    return a[1] - b[1];
                });
                sortable.map((item) => {
                    quotes_string += item[0].slogan + (sortable.length > i ? " - " : "");
                    i++;
                });

                if (this.state.customIndustry) {
                    quotes_string = this.state.customIndustry + " | " + quotes_string;
                }

            } else {
                quotes_string = this.state.quotes.text;
            }
            return quotes_string
        }
    }

    //CANVAS
    _renderCanvasImage() {
        try {
            let cart = cartRegister.get();
            return cart.admin_image.images.large;
        } catch (e) {}
    }

    _renderText(item) {
        return langRegister.get("signup-ads", item);
    }

    render() {
        return (
            <div className={Styles.contentContainerLeftItem}>
                {
                    this.state.selected && this.state.available &&
                    <div onClick={() => this._placement()} className={Styles.contentContainerLeftItemPlacement}>
                        <img src={require("../../assets/images/plus_sign_white_small.png")}
                             className={Styles.contentContainerLeftItemPlacementIcon}/>
                    </div>
                }
                <div className={
                    cx(Styles.contentContainerLeftItemInner,
                        {
                            [Styles.contentContainerLeftItemInnerActive]: !this.state.selected,
                        })
                }>
                    <div
                        className={
                            cx(Styles.contentContainerLeftItemInnerOverlay,
                                {
                                    [Styles.contentContainerLeftItemInnerOverlayActive]: !this.state.selected,
                                })
                        }
                    >
                        {
                            !this.state.selected &&
                            <div onClick={() => {
                                if (this.state.available) {
                                    this.props.selectChannel("googledisplay");
                                    this.setState({selected: !this.state.selected})
                                }
                            }}
                                 className={cx(Styles.contentContainerLeftItemInnerOverlayButton,
                                     {
                                         [Styles.contentContainerLeftItemInnerOverlayButtonComingPropertyBooster]: salesChannelRegister.get('name')==='propertybooster' && !this.state.available,
                                         [Styles.contentContainerLeftItemInnerOverlayButtonComingBoostaBostad]: salesChannelRegister.get('name')==='boostabostad' && !this.state.available,
                                         [Styles.contentContainerLeftItemInnerOverlayButtonComingYieldlock]: salesChannelRegister.get('name')==='yieldlock' && !this.state.available,
                                     })
                                 }>
                                {
                                    this.state.available &&
                                    this._renderText("item_18")
                                }
                                {
                                    !this.state.available &&
                                    this._renderText("item_67")
                                }
                            </div>
                        }
                        <div className={Styles.contentContainerLeftItemInnerOverlayTitle}>
                            Google <span
                            className={Styles.contentContainerLeftItemInnerOverlayTitleSmall}>display ads</span>
                        </div>
                        {
                            this.state.tips.filter((item, key) => {
                                return !this.state.learn_more && key < 3 || this.state.learn_more && key > 2
                            }).map((prop, i) => {
                                return (
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} key={i}
                                         className={Styles.contentContainerLeftItemInnerOverlayItem}>
                                        &#x2b; {prop.title}
                                    </div>
                                )
                            })
                        }
                        <div onClick={() => {
                            this.setState({learn_more: !this.state.learn_more})
                        }} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.contentContainerLeftItemInnerOverlayReadMore}>
                            {
                                this.state.learn_more &&
                                <span>{this._renderText("item_28")}</span>
                            }
                            {
                                !this.state.learn_more &&
                                <span>{this._renderText("item_29")}</span>
                            }
                        </div>
                    </div>
                    <div className={Styles.contentContainerLeftItemGoogleDisplayInnerTop}>
                    </div>
                </div>
                <div className={Styles.contentContainerLeftItemBottom}>
                    <div
                        className={
                            cx(Styles.contentContainerLeftItemBottomIconContainer,
                                {
                                    [Styles.contentContainerLeftItemBottomIconContainerActive]: this.state.selected,
                                })
                        }
                    >
                        <img
                            className={Styles.contentContainerLeftItemBottomIconContainerIconGoogleDisplay}
                            src={require("../../assets/images/google_logo_icon.svg")}/>
                    </div>
                    {
                        !this.state.selected && this.state.available &&
                        <img onClick={() => {
                            this.props.selectChannel("googledisplay");
                            this.setState({selected: !this.state.selected}, () => {
                                if (!this.state.selected) {
                                    this._selectAdType("canvas")
                                }
                            })
                        }}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_deactive.svg")}/>
                    }
                    {
                        this.state.selected && this.state.available && salesChannelRegister.get('name') === 'propertybooster' &&
                        <img onClick={() => {
                            this.props.selectChannel("googledisplay");
                            this.setState({selected: !this.state.selected}, () => {
                                if (!this.state.selected) {
                                    this._selectAdType("canvas")
                                }
                            })
                        }}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_active.svg")}/>
                    }
                    {
                        this.state.selected && this.state.available && salesChannelRegister.get('name') === 'boostabostad' &&
                        <img onClick={() => {
                            this.props.selectChannel("googledisplay");
                            this.setState({selected: !this.state.selected}, () => {
                                if (!this.state.selected) {
                                    this._selectAdType("canvas")
                                }
                            })
                        }}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_active_boostabostad.svg")}/>
                    }
                    {
                        this.state.selected && this.state.available && salesChannelRegister.get('name') === 'yieldlock' &&
                        <img onClick={() => {
                            this.props.selectChannel("googledisplay");
                            this.setState({selected: !this.state.selected}, () => {
                                if (!this.state.selected) {
                                    this._selectAdType("canvas")
                                }
                            })
                        }}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_active_yl.svg")}/>
                    }
                    {
                        !this.state.selected && !this.state.available &&
                        <div className={Styles.contentContainerLeftItemBottomDots}>
                            <div className={
                                cx(Styles.contentContainerLeftItemBottomDotsItem,
                                    {
                                        [Styles.contentContainerLeftItemBottomDotsItemActive]: !this.state.learn_more,
                                    })
                            }/>
                            <div className={Styles.contentContainerLeftItemBottomDotsItemLine}/>
                            <div className={
                                cx(Styles.contentContainerLeftItemBottomDotsItem,
                                    {
                                        [Styles.contentContainerLeftItemBottomDotsItemActive]: this.state.learn_more,
                                    })
                            }/>
                        </div>
                    }
                    {
                        this.state.selected && this.state.available &&
                        <div className={Styles.contentContainerLeftItemBottomShowBoxes}>
                            {
                                this.state.ad_types.canvas.available &&
                                <div className={
                                    cx(Styles.contentContainerLeftItemBottomShowBoxesItem,
                                        {
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActive]: this.state.ad_types.canvas.selected,
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActiveYieldlock]: this.state.ad_types.canvas.selected && salesChannelRegister.get('name')==='yieldlock',

                                        })
                                } onClick={() => this._selectAdType("canvas")}>
                                    <img className={Styles.contentContainerLeftItemBottomShowBoxesItemIcon}
                                         src={require("../../assets/images/AB_Ad_Image.png")}/>
                                </div>
                            }
                            {
                                this.state.ad_types.video.available &&
                                <div className={
                                    cx(Styles.contentContainerLeftItemBottomShowBoxesItem,
                                        {
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActive]: this.state.ad_types.video.selected,
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActiveYieldlock]: this.state.ad_types.video.selected && salesChannelRegister.get('name')==='yieldlock',

                                        })
                                } onClick={() => this._selectAdType("video")}>
                                    {
                                        <img className={Styles.contentContainerLeftItemBottomShowBoxesItemIconVideo}
                                             src={require("../../assets/images/AB_Ad_Video.png")}/>
                                    }
                                </div>
                            }
                            {
                                this.state.ad_types.carousel.available &&
                                <div className={
                                    cx(Styles.contentContainerLeftItemBottomShowBoxesItem,
                                        {
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActive]: this.state.ad_types.carousel.selected,
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActiveYieldlock]: this.state.ad_types.carousel.selected && salesChannelRegister.get('name')==='yieldlock',

                                        })
                                } onClick={() => this._selectAdType("carousel")}>
                                    <img className={Styles.contentContainerLeftItemBottomShowBoxesItemIcon}
                                         src={require("../../assets/images/AB_Ad_Carusel.png")}/>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default SignupAdsGoogleDisplay;


// WEBPACK FOOTER //
// ./src/components/signup-ads-google-display/component.js